import React, { useState } from 'react';
import { cn } from '@/lib/utils';
import { trackMediaLoadErrorFromElement } from '@/lib/reportMediaLoadError';
import { MediaUnavailable } from './MediaUnavailable';

export const Image: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({
  className,
  onError,
  src,
  ...props
}) => {
  const [hasError, setHasError] = useState(false);

  const handleError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    trackMediaLoadErrorFromElement(event.currentTarget);
    setHasError(true);
    onError?.(event);
  };

  if (!src || hasError) {
    return <MediaUnavailable className={className} />;
  }

  return (
    <img
      src={src}
      className={cn(className)}
      onError={handleError}
      {...props}
    />
  );
};
